import { render, staticRenderFns } from "./StudentRoutesSection.vue?vue&type=template&id=47bf30f8&scoped=true"
import script from "./StudentRoutesSection.vue?vue&type=script&lang=js"
export * from "./StudentRoutesSection.vue?vue&type=script&lang=js"
import style0 from "./StudentRoutesSection.vue?vue&type=style&index=0&id=47bf30f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf30f8",
  null
  
)

export default component.exports